export class NavigationRoutes {
    static dashboard = '/';
    static login = '/login';
    static profile = '/profile';
    static forgottenPassword = '/forgotten-password';
    static resetPassword = '/reset-password';
    static updateProfile = 'update';
    static updatePassword = 'update-password';
    static admin = '/admin';
    static userManagement = '/admin/user-management';
    static userView = 'user';
    static createUser = 'create-user';
    static drugManagement = '/admin/drug-management';
    static drugView = 'drug';
    static createDrug = 'create-drug';
    static storageManagement = '/admin/storageManagement-management';
    static storageView = 'storageManagement';
    static createStorage = 'create-storageManagement';
    static deviations = '/admin/deviations';
    static organizations = '/admin/organizations';
    static deviationView = 'deviation';
    static transaction = '/transaction';
    static crossCheck = 'inventory';
    static deposit = 'deposit';
    static withdrawal = 'withdrawal';
    static disposed = 'disposed';
    static chainedTransaction = 'chained-transaction';
    static shiftChangeInventory = 'shift-change-inventory';
    static shiftCrossCheck = 'shift-cross-check';
    static callback = '/callback';
    static tenantOrganizations = '/admin/super/tenant-organizations';
    static tenantOrganizationsView = '/admin/super/tenant-organizations-view';
    static createTenantOrganizations =
        '/admin/super/create-tenant-organization';
    static updateTenantOrganizations =
        '/admin/super/update-tenant-organization';
    static tenants = '/admin/super/tenants';
    static tenantView = 'tenant';
    static createTenant = 'create-tenant';
    static updateTenant = '/admin/super/tenants/tenant/update-tenant'; //When going from tenant view to update tenant
    static afterCreateTenant = '/admin/super/tenants/tenant/update-tenant';
    static reports = '/admin/reports';
    static labelPrinting = '/admin/label-printing';

    // Messages
    static messages = '/admin/messages';
    static messageDetail = '/admin/messages/:id';
    static createMessage = '/admin/messages/create';

    // Organization Settings
    static organizationSettings = '/admin/organization-settings';

    static pageNotFound = '/404';

    static devTheme = '/dev/theme';
    static devMessage = '/dev/message';
    static devComponents = '/dev/components';
    static support = '/support';
    static feedback = '/admin/feedback';
    static feedbackDetail = '/admin/feedback/:id';
}
